(() => {
  const measurementLabels = {
    'text-1': 'Bust',
    'text-2': 'Waist',
    'text-3': 'Hips',
    'text-4': 'Hollow to floor',
    'text-5': 'Height',
    'text-6': 'Arm length',
    'text-7': 'Armhole',
    'text-8': 'Shoulder to shoulder',
    'text-9': 'Armpit'
  };
  const measurementLetters = {'text-1':'A', 'text-2':'B', 'text-3':'C', 'text-4':'D', 'text-5':'E', 'text-7':'F', 'text-8':'G', 'text-6':'H', 'text-9':'I'};

  const setLabel = (group, text) => {
    const label = group?.querySelector('.gpo-label .label-content');
    if (label) label.textContent = text;
  };

  const enhance = app => {
    if (app.dataset.customFitEnhanced) return;
    const fitGroup = app.querySelector('[data-element-id="radio-1"]');
    const yes = fitGroup?.querySelector('input[type="radio"][value="YES"]');
    const no = fitGroup?.querySelector('input[type="radio"][value="NO"]');
    if (!yes || !no) return;
    const yesChoice = yes.closest('.gpo-choicelist');
    const noChoice = no.closest('.gpo-choicelist');
    if (!yesChoice || !noChoice) return;

    app.dataset.customFitEnhanced = 'true';
    app.classList.add('pdp-fit-options');
    fitGroup.classList.add('pdp-fit-selector');
    setLabel(fitGroup, 'Choose her fit');
    const choices = document.createElement('div');
    choices.className = 'pdp-fit-choices';
    noChoice.before(choices);
    choices.append(noChoice, yesChoice);

    const decorateChoice = (choice, title, description) => {
      const label = choice.querySelector('label');
      if (!label) return;
      choice.classList.add('pdp-fit-card');
      const titleElement = [...label.children].find(child => child.tagName === 'SPAN' && !child.classList.contains('addOn'));
      if (titleElement) {
        // Keep the vendor fee span in place, even when it is nested in the title.
        [...titleElement.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
        titleElement.prepend(document.createTextNode(title));
        titleElement.classList.add('pdp-fit-card__title');
      }
      const note = document.createElement('span');
      note.className = 'pdp-fit-card__note';
      note.textContent = description;
      label.append(note);
    };
    decorateChoice(noChoice, 'Standard sizing', 'Choose a size above');
    decorateChoice(yesChoice, 'Made to measure', 'Tailored to her measurements');

    const measurementFields = [...app.querySelectorAll('[data-element-id]')].filter(group => measurementLabels[group.dataset.elementId]);
    const measurements = document.createElement('section');
    measurements.className = 'pdp-measurement-fields';
    measurements.setAttribute('aria-label', 'Your measurements');
    const measurementHead = document.createElement('div');
    measurementHead.className = 'pdp-measurement-fields__head';
    const heading = document.createElement('h3');
    heading.textContent = 'Your measurements';
    const unit = document.createElement('p');
    unit.textContent = 'Enter all measurements in inches.';
    const guide = document.createElement('a');
    guide.href = '#product-measurements';
    guide.textContent = 'How to measure';
    measurementHead.append(heading, unit, guide);
    const measurementGrid = document.createElement('div');
    measurementGrid.className = 'pdp-measurement-fields__grid';
    measurementFields.forEach(group => {
      setLabel(group, measurementLabels[group.dataset.elementId]);
      const label = group.querySelector('.gpo-label .label-content');
      if (label) {
        const marker = document.createElement('span');
        marker.className = 'pdp-measurement-letter';
        marker.textContent = measurementLetters[group.dataset.elementId];
        label.prepend(marker, document.createTextNode(' '));
      }
      const input = group.querySelector('input');
      if (group.dataset.elementId === 'text-4' && input?.placeholder) input.placeholder = input.placeholder.replace(/hallow/ig, 'Hollow');
      measurementGrid.append(group);
    });
    measurements.append(measurementHead);
    const guideTemplate = app.closest('[data-product-root]')?.querySelector('[data-custom-measure-guide]');
    if (guideTemplate) measurements.append(guideTemplate.content.cloneNode(true));
    measurements.append(measurementGrid);

    const timing = document.createElement('div');
    timing.className = 'pdp-tailoring-fields';
    const dateGroup = app.querySelector('[data-element-id="datetime-1"]');
    const tailoringGroup = app.querySelector('[data-element-id="select-1"]');
    if (dateGroup) {
      setLabel(dateGroup, 'Event date');
      const date = dateGroup.querySelector('input.gpo-datetime, input[data-type="datetime"]');
      if (date) date.placeholder = 'Select event date';
      timing.append(dateGroup);
    }
    if (tailoringGroup) {
      setLabel(tailoringGroup, 'Tailoring time');
      const blank = tailoringGroup.querySelector('select option[value=""]');
      if (blank) blank.textContent = 'Choose tailoring time';
      timing.append(tailoringGroup);
    }
    app.prepend(fitGroup);
    fitGroup.after(measurements);
    measurements.after(timing);

    const updateFit = () => {
      const active = yes.checked;
      app.dataset.fitActive = String(active);
      measurements.dataset.fitActive = String(active);
      measurements.hidden = !active;
      yesChoice.classList.toggle('is-selected', active);
      noChoice.classList.toggle('is-selected', no.checked);
    };
    yes.addEventListener('change', updateFit);
    no.addEventListener('change', updateFit);
    updateFit();
    // Let the original change handlers set line-item properties and conditional fields.
    requestAnimationFrame(() => {
      if (!app.isConnected) return;
      if (!yes.checked && !no.checked) no.click();
      updateFit();
    });
  };

  const enhanceAll = () => document.querySelectorAll('[data-product-root] .gpo-app').forEach(enhance);
  document.addEventListener('GLOBO_OPTIONS_RENDERED', enhanceAll);
  enhanceAll();
})();
